// extracted by mini-css-extract-plugin
module.exports = {"select":"LocaleSelectSolo_select_37nOL"};